import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('notFoundPage.title')} — SaleSign`;
  }, [t]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6 py-12">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl shadow-sm p-8 text-center">
        <p className="text-5xl sm:text-6xl font-bold text-gray-200 select-none" aria-hidden>
          404
        </p>
        <h1 className="mt-2 text-2xl font-bold text-gray-900">{t('notFoundPage.title')}</h1>
        <p className="mt-3 text-gray-600">{t('notFoundPage.message')}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center justify-center rounded-lg btn-primary px-6 py-3 text-sm font-medium text-white"
        >
          {t('notFoundPage.goHome')}
        </Link>
      </div>
    </div>
  );
}
